import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { disableLoginPopUps } from "@/redux/actions/patient";
import { Portal } from "@/components/Common/Modal/Portal";
import { selectAllowWaitListPopUp } from "@/redux/selectors/patientSelectors";
import {
  selectIsPatientInactive,
  selectIsPatientWaitListed,
} from "@/redux/selectors/authSelectors";
import { SUPPORT_EMAIL, SUPPORT_EMAIL_HREF } from "@/constants/aptihealth";
import { Text } from "@/component-library";

export function WaitListModal() {
  const dispatch = useDispatch();
  const isInactive = useSelector(selectIsPatientInactive);
  const isWaitListed = useSelector(selectIsPatientWaitListed);
  const allowWaitListPopUp = useSelector(selectAllowWaitListPopUp);

  // Inactive modal takes priority — don't show both
  if (isInactive || !isWaitListed || !allowWaitListPopUp) return null;

  return (
    <Portal
      className="take-assessment-modal"
      headerRender={<h5 className="border-bottom-0 tw:font-bold"></h5>}
      isBottomCloseActive={false}
      isOpenOnRender={true}
      onModalClose={() => dispatch(disableLoginPopUps())}
    >
      <div className="text-align-center mb-5 mx-5">
        <p className="mb-3">
          <Text type="heading-1">You're on the Waitlist</Text>
        </p>

        <p className="pb-2">
          <Text color="grey" type="paragraph">
            Hi there. We're working on finding a provider that's the best match for you. It may take
            some time to assemble your care team, and we appreciate your patience.
          </Text>
        </p>

        <p className="pb-2">
          <Text color="grey" type="paragraph">
            If you have a medical or life-threatening emergency, please call 911, go to the nearest
            emergency room, or contact the National Suicide Prevention Lifeline at 988.
          </Text>
        </p>

        <p>
          <Text color="grey" type="paragraph">
            For questions about waitlist status, contact our team at&nbsp;
          </Text>

          <Text
            className="patient-contact-link"
            onClick={() => window.open(SUPPORT_EMAIL_HREF)}
            type="paragraph"
          >
            {SUPPORT_EMAIL}
          </Text>

          <Text color="grey" type="paragraph">
            .
          </Text>
        </p>
      </div>
    </Portal>
  );
}
